import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiAvatar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2702 10.717C12.3619 10.7716 12.4753 10.8356 12.6036 10.908C13.1658 11.2252 14.0157 11.7047 14.5979 12.2746C14.9621 12.631 15.3081 13.1007 15.371 13.6761C15.4379 14.2881 15.1709 14.8624 14.6353 15.3726C13.7113 16.2529 12.6025 16.9583 11.1683 16.9583H4.2128C2.77859 16.9583 1.66977 16.2529 0.745775 15.3726C0.210193 14.8624 -0.0567736 14.2881 0.0101185 13.6761C0.0730187 13.1007 0.419011 12.631 0.783157 12.2746C1.36539 11.7047 2.21529 11.2252 2.77753 10.908C2.90583 10.8356 3.01916 10.7716 3.1109 10.717C5.91419 9.04782 9.46691 9.04782 12.2702 10.717Z",
			fill: "#363F5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.54956 4.14099C3.54956 1.85398 5.40354 0 7.69055 0C9.97756 0 11.8315 1.85398 11.8315 4.14099C11.8315 6.428 9.97756 8.28198 7.69055 8.28198C5.40354 8.28198 3.54956 6.428 3.54956 4.14099Z",
			fill: "#363F5A"
		})
	]
});
const ForwardRef = forwardRef(SvgAiAvatar);
export default ForwardRef;
